module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAeElEQVQ4T82S0Q2AIAxE7zZwE1dwBEd1BFZgEzeogRgSpGAbfuCPhHv0rkdMHk7qsQhARE4Au9NOJHllCyKyAQgOSARwkLxLBg5IEafPqxANkErcAH7sNGIV0IGo4i7gA0nXHJi2pWGR3kzQEw8nsHZikSpbx9XePdD9LBFY+ZE1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/components/pageTitle/arr_down.png
// module id = 159
// module chunks = 17 18